const t = {
  name: "Information",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 4.5C13.24 4.5 14.25 3.49 14.25 2.25C14.25 1.01 13.24 0 12 0C10.76 0 9.75 1.01 9.75 2.25C9.75 3.49 10.76 4.5 12 4.5Z" fill="currentColor"/>
<path d="M8 7V9H10V22H8V24H16V22H14V7H8Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Information
};
